/** A trimmed form value, or undefined when it is blank, so blank fields are left out of a request. */
export const trimmedOrUndefined = (value: string): string | undefined => value.trim() || undefined;
